import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import companylogo from "../../assets/dctlogo.png";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import { LuPackagePlus } from "react-icons/lu";
import LocalShippingSharpIcon from "@mui/icons-material/LocalShippingSharp";
import { Link } from "react-router-dom";
import AnalyticsIcon from "@mui/icons-material/Analytics";

export default function NavDrawer() {
	const linker = "dctdashboard/admin/admin-setting";

	const [open, setOpen] = React.useState(false);

	const toggleDrawer = (newOpen) => () => {
		setOpen(newOpen);
	};

	const DrawerList = (
		<Box
			sx={{ width: 250, height: "100vh", color: "white", bgcolor: "#034052" }}
			role="presentation"
			onClick={toggleDrawer(false)}>
			<img
				src={companylogo}
				alt="Direct cargo express logo"
				className="w-[10rem] m-[1rem]   mr-auto"
			/>

			<List>
				{[
					{ pathName: "Dashboard", url: "", id: 1 },
					{ pathName: "Create Shipment", url: "create-shipment", id: 2 },
					{ pathName: "Update Shipment", url: "update-shipment", id: 3 },
					// { pathName: "Analytics", url: "analytics", id: 4 },
				].map((data, index) => (
					<ListItem key={data.id} disablePadding>
						<ListItemButton>
							<ListItemIcon sx={{ color: "white" }}>
								{/* {index % 2 === 0 ? <InboxIcon /> : <MailIcon />} */}
								{data.pathName === "Dashboard" ? (
									<DashboardIcon />
								) : data.pathName === "Create Shipment" ? (
									<LuPackagePlus className="text-[1.5rem]" />
								) : data.pathName === "Analytics" ? (
									<AnalyticsIcon />
								) : (
									data.pathName === "Update Shipment" && (
										<LocalShippingSharpIcon />
									)
								)}
							</ListItemIcon>
							{/* <ListItemText primary={text} /> */}
							<Link to={`/dctdashboard/admin/${data.url}`}>
								{data.pathName}
							</Link>
						</ListItemButton>
					</ListItem>
				))}
			</List>
			<Divider sx={{ bgcolor: "gray", width: "80%", mr: "auto", ml: "1rem" }} />
			<List>
				{[
					// { pathName: "Support", url: "", id: 1 },
					{
						pathName: "Setting",
						url: "admin-setting",
						id: 1,
					},
					{ pathName: "Logout", url: "logout", id: 2 },
				].map((data, index) => (
					<ListItem key={data.id} disablePadding>
						<ListItemButton>
							<ListItemIcon sx={{ color: "white" }}>
								{/* {index % 2 === 0 ? <InboxIcon /> : <MailIcon />} */}
								{data.pathName === "Support" ? (
									<HeadphonesIcon />
								) : data.pathName === "Settings" ? (
									<SettingsIcon />
								) : (
									<LogoutIcon />
								)}
							</ListItemIcon>
							{/* <ListItemText primary={text} /> */}
							<Link to={`/dctdashboard/admin/${data.url}`}>
								{data.pathName}
							</Link>
						</ListItemButton>
					</ListItem>
				))}
			</List>
		</Box>
	);

	return (
		<div className=" min-h-full  text-black">
			<Button onClick={toggleDrawer(true)}>
				<MenuOpenIcon sx={{ color: "black", width: "3rem" }} />
			</Button>
			<Drawer open={open} onClose={toggleDrawer(false)}>
				{DrawerList}
			</Drawer>
		</div>
	);
}
